<template>
    <v-menu
        v-model="sortMenu"
        width="360"
        max-width="360"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                class="rounded-xxl text-none px-4"
                data-testid="orders-sort-button"
            >
                {{ sortLastCreated ? $t('sortLastCreated') : $t('sortBy') }}
                <v-icon
                    right
                    color="accent"
                >
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item data-testid="orders-sort-last-created" @click="setSort('lastCreated')">
                <v-list-item-title>{{ $t('sortLastCreated') }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>
export default {
    name: 'SortOptions',
    props: {
        sortLastCreated: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            sortMenu: false
        }
    },
    methods: {
        setSort(value) {
            this.$emit('setSort', value)
        }
    }
}
</script>